import React, {lazy, Suspense} from 'react';
import {Router, Switch, Redirect} from 'react-router-dom';

// import PropTypes from "prop-types";

// Floating:
// import ChatApp from "./components/chatComponents/chatApp";
// import ChatApp from "../widgetComponent/openWidgetComponent/ChatComponent/chatApp";

// Common
import PrivateRoute from './privateRoute';
import PublicRoute from './publicRoute';
import {AppContext} from './Context';
import history from './history';
import './Main.css';
// import CallInPopupComponent from '../screens/CallInPopup/CallInPopupComponent';
import WidgetContainerComponent from '../screens/WidgetContainerComponent/WidgetContainerComponent';
import WidgetContextProvider from '../components/widgetComponent/widgetContextProvider';
import ToastWrapperComponent from '../components/common/genericComponents/redesign/toastWrapperComponent/toastWrapperComponent';
import utilsService from '../services/utilsService';
import VIDABOO_CONSTANTS from '../config/consts';
import NotificationComponent from '../components/common/genericComponents/notificationComponent';
import EmailOptOutScreen from '../screens/emailOptOutScreen/emailOptOutScreen';
// import AnimatedLogoComponent from '../components/common/genericComponents/animatedLogoComponent';

const PublicMediaScreen = lazy(
  () => import('../screens/PublicMediaScreen/publicMediaScreen'),
);

const ExpertHome = lazy(
  () => import('../screens/ExpertHome/ExpertHomeComponent'),
);

const AuthenticationScreen = lazy(
  () => import('../screens/AuthenticationScreen/AuthenticationScreen'),
);

const AnonymousSchedulingScreen = lazy(
  () =>
    import('../screens/anonymousSchedulingScreen/anonymousSchedulingScreen'),
);
// const TestScreen = lazy(() => import('../screens/TestScreen/TestScreen'));

const GiftPage = lazy(
  () => import('../screens/redeemGiftsScreen/redeemGiftsComponent'),
);

const MeetingRoomScreen = lazy(
  () => import('../screens/meetingRoomScreen/meetingRoomScreen'),
);

// import AnimatedLogoComponent from "../components/common/genericComponents/animatedLogoComponent";
// import PublicMediaScreen from '../screens/PublicMediaPlayer/publicMediaScreen';
// 1. user changes Route (either goes to another link OR refreshes browser(F5))
// 2. webapp should refresh "currentUser" by accessing requireAuth
// 3. after requireAuth returns a value (could be async), we check whether we may access

export default class Main extends React.Component {
  // ...
  componentDidMount = async () => {
    // check if we're in
    await this.context.authenticationService.requireAuth();
    this.handleAccessToBackOffice();
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', this.handleSWMessage);
    }
  };

  componentWillUnmount() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.removeEventListener(
        'message',
        this.handleSWMessage,
      );
    }
  }

  handleSWMessage = (event) => {
    if (event?.data?.type === 'ping-from-sw') {
      // console.debug('Message from SW: ', event.data);
      if (navigator?.serviceWorker?.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'pong-from-page',
          pingTimestamp: event.data.timestamp,
          timestamp: Date.now(),
          message: 'IM_ALIVE',
        });
      }
    }
  };

  handleAccessToBackOffice = () => {
    if (!utilsService.getIsClient()) {
      //if we are in backoffice
      if (window.location.origin === VIDABOO_CONSTANTS.APP_PAGE) {
        //nothing needs to be done
      } else {
        //probably cname
        // window.history.pushState({}, '', '/login'); //this will update the address bar but will not reload the page -> url at this point looks like https://my-ip.yuvidio.com:3000/login
        this.context.setNotificationPopUpData({
          notificationTxt:
            'Seems like there is nothing here. You will be redirected.',
          notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
          closeBtnFunc: () => {
            const url =
              VIDABOO_CONSTANTS.APP_PAGE +
              window.location.pathname +
              window.location.search;
            window.location.href = url;
            this.context.closeNotificationPopUp();
          },
        });
        this.context.setShowNotificationPopUp(true);
      }
    }
  };

  render() {
    return (
      <AppContext.Consumer>
        {(context) => {
          if (context.currentUser.userId === undefined) return;

          let {isAuthorised} = context;
          return (
            <Suspense
              fallback={
                <div
                  style={{
                    margin: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'start',
                    width: '150px',
                    textAlign: 'center',
                  }}>
                  {/* <AnimatedLogoComponent fillColor="#2d2756" /> */}
                  <b>Loading....</b>
                </div>
              }>
              <Router history={history}>
                <main className="pageContainer">
                  <WidgetContextProvider>
                    <Switch>
                      {/* BACKOFFICE SIDE:  */}
                      <PrivateRoute
                        isAuthorised={isAuthorised}
                        path="/expertHome"
                        component={ExpertHome}
                      />
                      <PublicRoute
                        exact
                        path="/login"
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/redeemGift"
                        component={GiftPage}
                      />
                      <PublicRoute
                        exact
                        path="/emaildigest/:token"
                        component={EmailOptOutScreen}
                      />
                      <PublicRoute
                        exact
                        path="/appsumo-activation"
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/registration"
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/forgotpassword"
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/resetpassword"
                        component={AuthenticationScreen}
                      />
                      <Redirect
                        exact
                        from="/crid/:crid"
                        to="/expertHome/chatCenter/:crid"
                      />
                      <Redirect
                        exact
                        from="/bpid/:bpid"
                        to="/expertHome/settings/billingPlanId/:bpid"
                      />
                      <Redirect
                        exact
                        from="/calid/:bfiId"
                        to={{
                          pathname: '/expertHome/calendar/:bfiId',
                          search: history.location.search,
                        }}
                        // to="/expertHome/calendar/:bfiId"
                      />
                      <Redirect
                        exact
                        from={
                          VIDABOO_CONSTANTS.STRIPE_C2C_ONBOARDING_REDIRECT_PATH
                        }
                        to={{
                          pathname:
                            '/expertHome/settings/widgetSetup/setUpInstallation/paymentGateways',
                          search: history.location.search,
                        }}
                      />
                      {/* END BACKOFFICE SIDE */}
                      {/* CLIENT SIDE:  */}
                      {/* https://my-ip.yuvidio.com:3000/gmail-auth-callback?code=4/0AQlEd8xG2VFMDMi8gwa8AWONyNuZZte3bsM_Jd2jEVABiDtdH2JZxQq69_wvYbKBZttpRg&scope=https://mail.google.com/ */}
                      <Redirect
                        exact
                        from={VIDABOO_CONSTANTS.GOOGLE_EMAIL_AUTH_REDIRECT_PATH}
                        to={{
                          pathname:
                            '/expertHome/settings/personalSettings/integrations',
                          search: history.location.search,
                        }}
                      />
                      <PublicRoute
                        path="/m/:shortId"
                        component={MeetingRoomScreen}
                      />
                      <PublicRoute
                        path="/mb/:bfiId"
                        component={MeetingRoomScreen}
                      />
                      <PublicRoute
                        exact
                        path="/expertWidget/wid/:widgetId"
                        component={WidgetContainerComponent}
                      />
                      <PublicRoute
                        exact
                        path="/expertDir/wid/:widgetId"
                        component={WidgetContainerComponent}
                      />
                      <PublicRoute
                        path="/expertWidget/:mentorProfileName"
                        component={WidgetContainerComponent}
                      />
                      {/* <PublicRoute
                        path="/clickntalk/:mentorProfileName"
                        component={WidgetContainerComponent}
                      /> */}
                      <PublicRoute
                        path="/expert/:mentorProfileName"
                        component={WidgetContainerComponent}
                      />
                      <PublicRoute
                        exact
                        path="/cs/:bfiId"
                        component={AnonymousSchedulingScreen}
                      />
                      <PublicRoute
                        exact
                        path="/media/:publicMediaAccessString"
                        component={PublicMediaScreen}
                      />
                      {/* <PublicRoute
                        exact
                        path="/testScreen"
                        component={TestScreen}
                      /> */}
                      {/* <Redirect
                        exact
                        path="/expert/:mentorProfileName"
                        to={{
                          pathname: '/clickntalk/:mentorProfileName',
                          search: history.location.search,
                        }}
                      /> */}
                      {/* END CLIENT SIDE:  */}
                      <Redirect from="/" to="/expertHome/overview" />
                    </Switch>
                  </WidgetContextProvider>
                </main>
                {context.showNotificationPopUp && ( //todo : review with Ilan
                  <NotificationComponent
                    {...context.notificationPopUpData}
                    closeBtnFunc={
                      context.notificationPopUpData.closeBtnFunc ??
                      context.closeNotificationPopUp
                    }
                  />
                )}
                <ToastWrapperComponent />
              </Router>
              <div id="et-top-level-popup-portal-wrapper" dir="auto" />
            </Suspense>
          );
        }}
      </AppContext.Consumer>
    );
  }
}

Main.contextType = AppContext;
